import { useGridStore } from "../store/gridStore";

export function useGridMaximize() {
  const maximizedCellId = useGridStore((s) => s.maximizedCellId);
  const maximize = useGridStore((s) => s.maximize);
  const restore = useGridStore((s) => s.restore);

  const onCellDoubleClick = (cellId: string) => {
    if (maximizedCellId) restore();
    else maximize(cellId);
  };

  return { maximizedCellId, onCellDoubleClick, isMaximized: maximizedCellId !== null };
}
